import { useEffect, useState } from 'react';

interface MeterProps {
  pct: number;
  size: 'lg' | 'sm';
  tone: 'dark' | 'light';
}

export function Meter({ pct, size, tone }: MeterProps) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setAnimate(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  const fillGradient =
    pct >= 0.97
      ? 'bg-gradient-to-r from-red-400 to-red-500'
      : pct >= 0.8
        ? 'bg-gradient-to-r from-amber-400 to-amber-300'
        : 'bg-gradient-to-r from-emerald-400 to-emerald-300';

  const track = tone === 'dark' ? 'bg-white/10' : 'bg-gray-200';

  return (
    <div
      role="img"
      aria-label={`${Math.round(pct * 100)}% booked`}
      className={`w-full ${size === 'lg' ? 'h-2.5' : 'h-1.5'} rounded-full ${track} overflow-hidden`}
    >
      <div
        className={`h-full rounded-full ${fillGradient} motion-safe:transition-[width] motion-safe:duration-700 motion-safe:ease-out`}
        style={{ width: animate ? `${pct * 100}%` : '0%' }}
      />
    </div>
  );
}
